// import React, { useRef, useState } from "react";
// import { uploadDocuments } from "../../../services/user.services"; // Ensure correct path
// import { useDispatch, useSelector } from "react-redux";
// import Loader from "../../admin/leads/Loader";
// import toast from "react-hot-toast";
// import { setUserDetails } from "../../../state/reducers/userSlice";
// import { getStudentDetails } from "../../../services/admin.services";

// const UniversitySpecificSOP = () => {
//   const user_id = useSelector((state) => state.user.user_id);
//   const socket = useSelector((state) => state.user.socket);
//   const studentDetails = useSelector((state) => state.user.userDetails);
//   const [lorFiles, setLorFiles] = useState([
//     {
//       id: 1,
//       name: "University Specific SOP",
//       progress: 0,
//       status: "idle",
//       documentType: "uni_sop",
//       file: null, // Add file property to track actual file
//     },
//     {
//       id: 2,
//       name: "University Specific Essays",
//       progress: 0,
//       status: "idle",
//       documentType: "uni_essay",
//       file: null, // Add file property to track actual file
//     },
//   ]);

//   const [isSubmitting, setIsSubmitting] = useState(false); // State for loader
//   const fileInputRefs = useRef({});

//   const dispatch = useDispatch();

//   const getStudentProfile = async (user_id) => {
//     try {
//       const res = await getStudentDetails(user_id);
//       dispatch(setUserDetails(res.data));
//       return res.data; // <-- Important
//     } catch (err) {
//       console.log(err);
//     }
//   };

//   const resetUploadState = () => {
//     setLorFiles([
//       {
//         id: 1,
//         name: "University Specific SOP",
//         progress: 0,
//         status: "idle",
//         documentType: "uni_sop",
//         file: null,
//         fileName: "",
//       },
//       {
//         id: 2,
//         name: "University Specific Essays",
//         progress: 0,
//         status: "idle",
//         documentType: "uni_essay",
//         file: null,
//         fileName: "",
//       },
//     ]);

//     Object.values(fileInputRefs.current).forEach((input) => {
//       if (input) input.value = "";
//     });
//   };

//   const handleFileChange = (id, event) => {
//     const file = event.target.files[0];
//     if (file) {
//       // Update the state with the new file
//       setLorFiles((prevFiles) =>
//         prevFiles.map((lor) =>
//           lor.id === id
//             ? {
//                 ...lor,
//                 file: file, // Store the actual file object
//                 fileName: file.name, // Store the file name separately
//                 status: "completed", // Mark as completed immediately (we're not showing progress)
//                 progress: 100,
//               }
//             : lor
//         )
//       );
//     }
//   };

//   const handleUploadClick = (id) => {
//     fileInputRefs.current[id].click();
//   };

//   const handleSubmit = async () => {
//     // Check if both files are uploaded
//     const sopFile = lorFiles.find(
//       (lor) => lor.documentType === "uni_sop"
//     )?.file;
//     const essayFile = lorFiles.find(
//       (lor) => lor.documentType === "uni_essay"
//     )?.file;

//     if (!sopFile || !essayFile) {
//       toast.error("Please upload both University SOP and University Essays");
//       return;
//     }

//     setIsSubmitting(true); // Start loader
//     const formData = new FormData();
//     // Add files to FormData
//     formData.append("uni_sop", sopFile, sopFile.name);
//     formData.append("uni_essay", essayFile, essayFile.name);
//     formData.append("document_type", "uni_sop_essay");

//     try {
//       const response = await uploadDocuments(formData);
//       toast.success("Documents uploaded successfully!");
//       const updatedProfile = await getStudentProfile(user_id);
//       if (socket) {
//         socket.send(
//           JSON.stringify({
//             file_urls: response.data.uploaded_urls,
//             sender_id: user_id,
//             receiver_id:
//               studentDetails.assigned_admins.assigned_content_writer?.id,
//             room: socket.url.split("/")[5],
//           })
//         );
//       }
//       resetUploadState();
//     } catch (error) {
//       toast.error("Please Upload both University SOP and University Essays");
//       console.error("Upload error:", error);
//     } finally {
//       setIsSubmitting(false); // Stop loader
//     }
//   };

//   return (
//     <>
//       <div className="space-y-4 mt-4">
//         {lorFiles.map((lor, index) => (
//           <React.Fragment key={lor.id}>
//             <div className="bg-gray-100 p-4 rounded-md flex flex-wrap items-center">
//               <span className="block text-gray-700 font-medium mb-2 w-20 grow">
//                 {lor.documentType === "uni_sop"
//                   ? "University Specific SOP"
//                   : "University Specific Essays"}
//               </span>
//               <div
//                 className="border-2 border-dashed border-gray-300 rounded-md p-6 px-24 text-center cursor-pointer hover:border-purple-600 transition flex w-full max-w-sm items-center"
//                 onClick={() => handleUploadClick(lor.id)}
//               >
//                 <span className="text-gray-500">
//                   {lor.file
//                     ? `${lor.fileName} (Uploaded)`
//                     : `Click here to upload your ${lor.name}`}
//                 </span>
//               </div>
//               <input
//                 type="file"
//                 ref={(el) => (fileInputRefs.current[lor.id] = el)}
//                 style={{ display: "none" }}
//                 accept=".doc,.docx"
//                 onChange={(e) => handleFileChange(lor.id, e)}
//               />
//             </div>
//             {index === 0 && studentDetails.university_sop_url && (
//               <p>
//                 You have previously uploaded{" "}
//                 <b>{`${decodeURIComponent(
//                   studentDetails.university_sop_url.split(/[/\\]/).pop()
//                 )}`}</b>
//               </p>
//             )}
//             {index === 1 && studentDetails.university_essay_url && (
//               <p>
//                 You have previously uploaded{" "}
//                 <b>{`${decodeURIComponent(
//                   studentDetails.university_essay_url.split(/[/\\]/).pop()
//                 )}`}</b>
//               </p>
//             )}
//           </React.Fragment>
//         ))}
//       </div>
//       <div className="flex flex-col mt-12">
//         <div className="text-gray-500 text-sm text-center">
//           <p>Please upload your documents in Word Document only</p>
//         </div>
//         <div className="flex justify-end gap-8 pt-5">
//           <button type="button" className="text-gray-600 hover:text-gray-800">
//             Cancel
//           </button>
//           <button
//             type="button"
//             className={`bg-purple-600 text-white px-4 py-2 rounded-md ${
//               isSubmitting
//                 ? "opacity-70 cursor-not-allowed"
//                 : "hover:bg-purple-700"
//             } focus:outline-none focus:ring-2 focus:ring-purple-600 transition`}
//             onClick={handleSubmit}
//             disabled={isSubmitting}
//           >
//             {isSubmitting ? <Loader /> : "Submit"}
//           </button>
//         </div>
//       </div>
//     </>
//   );
// };

// export default UniversitySpecificSOP;
import React, { useEffect, useRef, useState } from "react";
import { uploadDocuments } from "../../../services/user.services";
import { useDispatch, useSelector } from "react-redux";
import Loader from "../../admin/leads/Loader";
import toast from "react-hot-toast";
import { setUserDetails } from "../../../state/reducers/userSlice";
import { getStudentDetails } from "../../../services/admin.services";

// ✅ Import WebSocket provider (same as Comments.jsx)
import { useWebSocket } from "../../../state/reducers/WebSocketProvider";

const genId = () => `cid_${Date.now()}_${Math.random().toString(36).slice(2)}`;

const UniversitySpecificSOP = () => {
  const user_id = useSelector((state) => state.user.user_id);
  const studentDetails = useSelector((state) => state.user.userDetails);

  const [lorFiles, setLorFiles] = useState([
    {
      id: 1,
      name: "University Specific SOP",
      progress: 0,
      status: "idle",
      documentType: "uni_sop",
      file: null,
      fileName: "",
    },
    {
      id: 2,
      name: "University Specific Essays",
      progress: 0,
      status: "idle",
      documentType: "uni_essay",
      file: null,
      fileName: "",
    },
  ]);

  const [isSubmitting, setIsSubmitting] = useState(false);
  const fileInputRefs = useRef({});
  const dispatch = useDispatch();

  // ✅ Use WebSocket provider (don't create connection, just use existing one)
  const { sendMessage, getConnectionState } = useWebSocket();

  // ✅ Room key matches Comments.jsx routing logic
  const roomKey = "university_specific_sop";

  const receiverId =
    studentDetails?.assigned_admins?.assigned_content_writer?.id || null;

  // ✅ Get connection state (created by Comments component)
  const connectionState = getConnectionState(roomKey, user_id);

  // ✅ Monitor connection state
  useEffect(() => {
    console.log("🔍 UniversitySpecificSOP connection state:", {
      roomKey,
      status: connectionState?.status,
      receiverId,
    });
  }, [connectionState, roomKey, receiverId]);

  const getStudentProfile = async (user_id) => {
    try {
      const res = await getStudentDetails(user_id);
      dispatch(setUserDetails(res.data));
      return res.data;
    } catch (err) {
      console.log(err);
    }
  };

  const resetUploadState = () => {
    setLorFiles([
      {
        id: 1,
        name: "University Specific SOP",
        progress: 0,
        status: "idle",
        documentType: "uni_sop",
        file: null,
        fileName: "",
      },
      {
        id: 2,
        name: "University Specific Essays",
        progress: 0,
        status: "idle",
        documentType: "uni_essay",
        file: null,
        fileName: "",
      },
    ]);

    Object.values(fileInputRefs.current).forEach((input) => {
      if (input) input.value = "";
    });
  };

  const handleFileChange = (id, event) => {
    const file = event.target.files[0];
    if (file) {
      setLorFiles((prevFiles) =>
        prevFiles.map((lor) =>
          lor.id === id
            ? {
                ...lor,
                file: file,
                fileName: file.name,
                status: "completed",
                progress: 100,
              }
            : lor
        )
      );
    }
  };

  const handleUploadClick = (id) => {
    fileInputRefs.current[id].click();
  };

  // ✅ Upload files to chat backend (same as Comments.jsx)
  const uploadFilesToChat = async (files) => {
    if (!files || files.length === 0) return [];

    try {
      const formData = new FormData();
      const fileArray = Array.isArray(files) ? files : [files];

      fileArray.forEach((file) => {
        formData.append("files", file);
      });

      // Add metadata
      const roomname = `${roomKey}_${user_id}`;
      formData.append("roomname", roomname);
      formData.append("sender_id", user_id);

      console.log(
        "📤 UniversitySpecificSOP: Uploading files to chat backend:",
        {
          roomname,
          fileCount: fileArray.length,
        }
      );

      const response = await fetch(
        `${process.env.REACT_APP_BASE_URL}/chat_app/api/upload-files/`,
        {
          method: "POST",
          body: formData,
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
        }
      );

      if (!response.ok) {
        throw new Error("Chat file upload failed");
      }

      const data = await response.json();
      console.log("✅ UniversitySpecificSOP: Chat files uploaded:", data);

      return data.file_urls || [];
    } catch (error) {
      console.error("❌ UniversitySpecificSOP: Chat file upload error:", error);
      throw error;
    }
  };

  const handleSubmit = async () => {
    // Check if both files are uploaded
    const sopFile = lorFiles.find(
      (lor) => lor.documentType === "uni_sop"
    )?.file;
    const essayFile = lorFiles.find(
      (lor) => lor.documentType === "uni_essay"
    )?.file;

    if (!sopFile || !essayFile) {
      toast.error("Please upload both University SOP and University Essays");
      return;
    }

    if (!receiverId) {
      toast.error("Assigned content writer not found. Please contact support.");
      return;
    }

    // ✅ Check if connection exists (from Comments component)
    if (!connectionState || connectionState.status !== "connected") {
      toast.error(
        "Chat is not connected. Please open the chat tab first and try again."
      );
      return;
    }

    setIsSubmitting(true);

    const formData = new FormData();
    formData.append("uni_sop", sopFile, sopFile.name);
    formData.append("uni_essay", essayFile, essayFile.name);
    formData.append("document_type", "uni_sop_essay");

    try {
      // ✅ STEP 1: Upload to document system
      console.log(
        "📤 UniversitySpecificSOP Step 1: Uploading to document system..."
      );
      const response = await uploadDocuments(formData);

      // ✅ STEP 2: Upload to chat system
      console.log(
        "📤 UniversitySpecificSOP Step 2: Uploading to chat system..."
      );
      const chatFileUrls = await uploadFilesToChat([sopFile, essayFile]);

      if (!chatFileUrls || chatFileUrls.length === 0) {
        throw new Error("Failed to upload files to chat system");
      }

      // ✅ STEP 3: Send message via existing WebSocket connection
      console.log(
        "📤 UniversitySpecificSOP Step 3: Sending message with file attachments..."
      );
      const cid = genId();

      sendMessage(roomKey, user_id, {
        message: "✅ University Specific SOP and Essays uploaded successfully",
        sender_id: user_id,
        receiver_id: receiverId,
        client_message_id: cid,
        file_urls: chatFileUrls,
      });

      console.log(
        "✅ UniversitySpecificSOP upload and chat notification complete"
      );

      toast.success("Documents uploaded successfully!");

      // Refresh student profile
      const updatedProfile = await getStudentProfile(user_id);

      // Reset upload state
      resetUploadState();
    } catch (error) {
      console.error("❌ UniversitySpecificSOP Upload Error:", error);
      toast.error(
        error.message ||
          "Please upload both University SOP and University Essays"
      );
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <>
      <div className="space-y-4 mt-4">
        {/* ✅ CONNECTION STATUS WARNINGS */}
        {!connectionState?.status && (
          <div className="mb-4 p-4 bg-yellow-50 border border-yellow-200 rounded-lg">
            <p className="text-yellow-800 text-sm font-medium">
              ⚠️ Chat not connected
            </p>
            <p className="text-yellow-600 text-xs mt-1">
              Please open the "University Specific SOP" chat tab first to enable
              notifications.
            </p>
          </div>
        )}

        {connectionState?.status === "connecting" && (
          <div className="mb-4 p-4 bg-blue-50 border border-blue-200 rounded-lg">
            <div className="flex items-center gap-2">
              <div className="w-4 h-4 border-2 border-blue-500 border-t-transparent rounded-full animate-spin"></div>
              <span className="text-blue-800 text-sm">
                Chat is connecting...
              </span>
            </div>
          </div>
        )}

        {connectionState?.status === "connected" && (
          <div className="mb-4 flex items-center gap-2">
            <span className="flex items-center gap-1 text-xs text-green-600">
              <div className="w-2 h-2 bg-green-400 rounded-full animate-pulse"></div>
              Chat connected - uploads will notify admin
            </span>
          </div>
        )}

        {!receiverId && studentDetails && (
          <div className="mb-4 p-4 bg-red-50 border border-red-200 rounded-lg">
            <p className="text-red-800 text-sm font-medium">
              ⚠️ No content writer assigned
            </p>
            <p className="text-red-600 text-xs mt-1">
              Please contact support to assign a content writer before
              uploading.
            </p>
          </div>
        )}

        {lorFiles.map((lor, index) => (
          <React.Fragment key={lor.id}>
            <div className="bg-gray-100 p-4 rounded-md flex flex-wrap items-center">
              <span className="block text-gray-700 font-medium mb-2 w-20 grow">
                {lor.documentType === "uni_sop"
                  ? "University Specific SOP"
                  : "University Specific Essays"}
              </span>
              <div
                className="border-2 border-dashed border-gray-300 rounded-md p-6 px-24 text-center cursor-pointer hover:border-purple-600 transition flex w-full max-w-sm items-center"
                onClick={() => handleUploadClick(lor.id)}
              >
                <span className="text-gray-500">
                  {lor.file
                    ? `${lor.fileName} (Uploaded)`
                    : `Click here to upload your ${lor.name}`}
                </span>
              </div>
              <input
                type="file"
                ref={(el) => (fileInputRefs.current[lor.id] = el)}
                style={{ display: "none" }}
                accept=".doc,.docx"
                onChange={(e) => handleFileChange(lor.id, e)}
              />
            </div>
            {index === 0 && studentDetails?.university_sop_url && (
              <p className="text-sm text-gray-600">
                Previously uploaded:{" "}
                <b className="text-gray-800">
                  {decodeURIComponent(
                    studentDetails.university_sop_url.split(/[/\\]/).pop()
                  )}
                </b>
              </p>
            )}
            {index === 1 && studentDetails?.university_essay_url && (
              <p className="text-sm text-gray-600">
                Previously uploaded:{" "}
                <b className="text-gray-800">
                  {decodeURIComponent(
                    studentDetails.university_essay_url.split(/[/\\]/).pop()
                  )}
                </b>
              </p>
            )}
          </React.Fragment>
        ))}
      </div>

      <div className="flex flex-col mt-12">
        <div className="text-gray-500 text-sm text-center">
          <p>Please upload your documents in Word Document only</p>
        </div>
        <div className="flex justify-end gap-8 pt-5">
          <button type="button" className="text-gray-600 hover:text-gray-800">
            Cancel
          </button>
          <button
            type="button"
            className={`bg-purple-600 text-white px-4 py-2 rounded-md ${
              isSubmitting || connectionState?.status !== "connected"
                ? "opacity-70 cursor-not-allowed"
                : "hover:bg-purple-700"
            } focus:outline-none focus:ring-2 focus:ring-purple-600 transition`}
            onClick={handleSubmit}
            disabled={isSubmitting || connectionState?.status !== "connected"}
          >
            {isSubmitting ? <Loader /> : "Submit"}
          </button>
        </div>
      </div>
    </>
  );
};

export default UniversitySpecificSOP;
